import { useMemo } from 'react';
import { formatCurrencyBRL } from '../utils/currencyDisplayHelpers';

export const useCurrencyDisplay = ({ value }) => {
  const formattedValue = useMemo(() => formatCurrencyBRL(value), [value]);

  return {
    formattedValue,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyDisplay/hooks/useCurrencyDisplay.js